import React, { useRef } from 'react';

import track from '@helper/tracking';

import Image from '../../atoms/image/image';
import Headline from '../../atoms/headline/headline';
import Copy from '../../atoms/copy/copy';
import Button from '../../atoms/button/button';
import CloseIcon from '../../icons/close.svg';
import FullscreenIcon from '../../icons/fullscreen/fullscreen';

import Lightbox from '../../atoms/lightbox/lightbox';

import { StyledGameTeaser, StyledLightbox } from './gameTeaser.style';

type GameTeaserProps = {
  topline?: string;
  headline: string;
  copy: string;
  cta?: string;
  iframeUrl: string;
  teaserImage: {
    src: string;
  };
};

const GameTeaser = ({ topline, headline, copy, cta, teaserImage, iframeUrl }: GameTeaserProps) => {
  const lightbox = useRef(null);

  return (
    <StyledGameTeaser>
      <div className="gameTeaser__image">{teaserImage && <Image {...teaserImage} />}</div>
      <div className="gameTeaser__content">
        <div className="gameTeaser__headline">
          {topline && (
            <Headline tag="h3" subline>
              {topline}
            </Headline>
          )}
          <Headline tag="h2" teaser>
            {headline}
          </Headline>
        </div>
        <div className="gameTeaser__copy">
          <Copy>{copy}</Copy>
          <Button
            className="gameTeaser__cta"
            onClick={() => {
              lightbox.current.openLightbox();
              track(['trackEvent', 'GameTeaser', 'Click', cta || 'Spiel öffnen']);
            }}
          >
            <FullscreenIcon />
            {cta || 'Spiel öffnen'}
          </Button>
        </div>
      </div>

      <Lightbox
        ref={lightbox}
        shouldCloseOnOverlayClick={false}
        shouldFocusAfterRender={false}
        shouldReturnFocusAfterClose={false}
      >
        <StyledLightbox>
          <iframe src={iframeUrl} title="Future Land Game" />
          <button
            type="button"
            onClick={() => lightbox.current.closeLightbox()}
            className="gameTeaser__close"
          >
            <CloseIcon width="35" height="35" />
          </button>
        </StyledLightbox>
      </Lightbox>
    </StyledGameTeaser>
  );
};

export default GameTeaser;
